"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// LB Shop Filters v1.0.0
var Filters = /** @class */ (function () {
    function Filters() {
        var _this = this;
        document.querySelectorAll('[data-lb-filter-types]').forEach(function (panel) {
            panel.addEventListener('change', function (event) {
                if (event.target instanceof HTMLInputElement && event.target.type === 'checkbox') {
                    _this.applyFilters(panel);
                }
            });
        });
        document.querySelectorAll('.js-refine-filters').forEach(function (select) {
            select.addEventListener('change', function () {
                var url = _this.firstPageUrl();
                if (select.value) {
                    url.searchParams.set('refine', select.value);
                }
                else {
                    url.searchParams.delete('refine');
                }
                window.location.assign(url.toString());
            });
        });
    }
    Filters.prototype.firstPageUrl = function () {
        var url = new URL(window.location.href);
        url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');
        url.searchParams.delete('paged');
        url.searchParams.delete('product-page');
        url.hash = '';
        return url;
    };
    Filters.prototype.applyFilters = function (panel) {
        var url = this.firstPageUrl();
        var types = (panel.getAttribute('data-lb-filter-types') || '').split(',');
        types.forEach(function (type) {
            if (type)
                url.searchParams.delete(type);
        });
        var selected = {};
        panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
            if (input.checked && input.name && types.indexOf(input.name) !== -1) {
                if (!selected[input.name])
                    selected[input.name] = [];
                selected[input.name].push(input.value);
            }
        });
        Object.keys(selected).forEach(function (name) {
            url.searchParams.set(name, selected[name].join(','));
        });
        panel.setAttribute('aria-busy', 'true');
        window.location.assign(url.toString());
    };
    return Filters;
}());
exports.default = Filters;
